<template>
  <div class="small-loader-container">
    <div class="small-loader">
      <div class="loader-ring"></div>
      <div class="loader-ring loader-ring-inner"></div>
    </div>
    <span v-if="showText" class="loader-label">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "SmallLoader",
  props: {
    showText: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: "Loading..."
    },
    size: {
      type: String,
      default: "medium", // small, medium, large
      validator: (value) => ['small', 'medium', 'large'].includes(value)
    }
  }
};
</script>

<style lang="scss" scoped>
.small-loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  gap: 16px;
}

.small-loader {
  position: relative;
  width: 48px;
  height: 48px;
}

.loader-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 3px solid #E2E8F0;
  border-top-color: #4D84FF;
  animation: spin 0.9s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.loader-ring-inner {
  width: 65%;
  height: 65%;
  top: 17.5%;
  left: 17.5%;
  border-width: 2px;
  border-color: #F1F5F9;
  border-right-color: #4D84FF;
  opacity: 0.8;
  animation: spinReverse 0.7s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.loader-label {
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #64748B;
  letter-spacing: 0.2px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes spinReverse {
  0% { transform: rotate(360deg); }
  100% { transform: rotate(0deg); }
}
</style>
